import { CHANGE_LOCALE, useLocaleContext } from './context';

const SWITCH_LOCAL = {
  en: 'ar',
  ar: 'en',
};
const useLocale = () => {
  const [locale, dispatch] = useLocaleContext();

  const toggleLocale = () => {
    const newLocale = SWITCH_LOCAL[locale];
    dispatch({
      type: CHANGE_LOCALE,
      payload: { locale: newLocale },
    });
  };

  const setLocale = (newLocale) => {
    dispatch({
      type: CHANGE_LOCALE,
      payload: { locale: newLocale },
    });
  };
  return { locale, toggleLocale, setLocale };
};
export default useLocale;
